<template>
  <RouterView />
  <CfToast ref="toastRef" />
</template>

<script setup lang="ts">
import { ref, provide } from 'vue'
import { RouterView } from 'vue-router'
import { CfToast, type ToastItem } from '@careerforge/ui'

const toastRef = ref<InstanceType<typeof CfToast> | null>(null)

function showToast(toast: Omit<ToastItem, 'id'>) {
  toastRef.value?.add(toast)
}

// Provide toast globally so all children can call inject('toast')
provide('toast', showToast)
</script>
